export const PACKAGES = [
  {
    key: "Economy",
    index: "01",
    tagline: "Essential clean",
    price: "From $300",
    accent: "lime",
    features: [
      "Exterior hand wash & dry",
      "Cabin vacuum & dusting",
      "Window & windscreen clean",
      "Tyre & landing gear wipe",
    ],
  },
  {
    key: "Premium Economy",
    index: "02",
    tagline: "Elevated detail",
    price: "From $450",
    accent: "lime",
    features: [
      "Everything in Economy",
      "Interior surface wipe-down",
      "Leather conditioning (seats)",
      "Brightwork clean & shine",
    ],
  },
  {
    key: "Business",
    index: "03",
    tagline: "Executive care",
    price: "From $850",
    accent: "purple",
    popular: true,
    features: [
      "Everything in Premium Economy",
      "Full interior deep detail",
      "Deep leather restoration",
      "Engine cowling polish",
    ],
  },
  {
    key: "First Class",
    index: "04",
    tagline: "White-glove concierge",
    price: "Bespoke",
    accent: "purple",
    features: [
      "Everything in Business",
      "Ceramic paint protection",
      "Full brightwork mirror polish",
      "Dedicated concierge manager",
    ],
  },
];

export const GALLERY = [
  {
    url: "https://images.pexels.com/photos/25724429/pexels-photo-25724429.jpeg",
    title: "Night Tarmac",
    cat: "Exterior",
    span: "wide",
  },
  {
    url: "https://images.unsplash.com/photo-1608062720349-a044e289748b",
    title: "Engine Bay",
    cat: "Precision",
    span: "tall",
  },
  {
    url: "https://images.unsplash.com/photo-1569679632387-78cd4c00f9da",
    title: "Cabin Interior",
    cat: "Interior",
    span: "normal",
  },
  {
    url: "https://images.pexels.com/photos/11213147/pexels-photo-11213147.jpeg",
    title: "Turbine Detail",
    cat: "Precision",
    span: "normal",
  },
  {
    url: "https://images.pexels.com/photos/236070/pexels-photo-236070.jpeg",
    title: "Private Fleet",
    cat: "Exterior",
    span: "wide",
  },
];

export const MANIFESTO = [
  {
    n: "01",
    title: "Laboratory precision",
    body: "Every aircraft is treated like a specimen. Controlled process, measured products, documented results. No shortcuts, no guesswork.",
  },
  {
    n: "02",
    title: "Aviation-grade only",
    body: "We use pH-balanced, aviation-approved products that protect paint, brightwork and composites without compromising surface integrity.",
  },
  {
    n: "03",
    title: "Detail obsessed",
    body: "From leaded-edge brightwork to cabin stitching, we work the millimetres others miss. The difference lives in the details.",
  },
];

export const CONTACTS = [
  { name: "Balraj Panesar", phone: "604-223-7362" },
  { name: "Justin Gill", phone: "778-979-7422" },
];

export const SOCIALS = {
  email: "aerodetaillab@outlook.com",
  instagram: "aero.detail.lab",
  tiktok: "aero.detail.lab",
};
